import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FILTER_TYPES, IFilterData } from 'src/app/core/feature-modules/table-filter/table-filter.interfaces';
import { LazyLoadEvent } from 'primeng/api';
import { DBService } from '../../core/backend-adapter/db.service';
import { SocketService } from '../../core/backend-adapter/socket.service';
import { NotifyService } from 'src/app/core/layouts/notifications/notify/notify.service';
import { TableFilterService } from 'src/app/core/feature-modules/table-filter/table-filter.service';
import { DialogService } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { AddEditResponseComponent } from '../components/add-edit-response/add-edit-response.component';
import {
  ICols,
  IFitersObject,
  IReviewData,
  IReviewsMetrics,
  IReviewsMetricsResponse,
} from '../review-management.interfaces';
import { DeletePopupComponent } from '../components/delete-popup/delete-popup.component';
import { SYSTEM_COLORS } from 'src/app/core/feature-modules/whitelabel/style-changer/styles/colors/system-colors.constants';
import { SessionService } from 'src/app/core/backend-adapter/session.service';
import { ExportDataToFile } from '../services/export-reviews-file.service';
import { Subject, from, zip } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IAccount } from 'src/app/acct-comps/accounts.interfaces';
import { ReviewsCopyClipboardService } from '../services/reviews-copy-clipboard.service';

@Component({
  selector: 'app-google-reviews-tab',
  templateUrl: './google-reviews-tab.component.html',
  styleUrls: ['./google-reviews-tab.component.scss'],
})
export class GoogleReviewsTabComponent implements OnInit, OnDestroy {
  SYSTEM_COLORS = SYSTEM_COLORS;
  @ViewChild('reviewTbl', { static: false }) reviewTbl: Table;

  datePosted: any[];
  keyword = '';
  sortOrder = '';
  filterData: IFilterData[] = [];
  chipsArray: string[] = [];
  showMultiReplyPopup = false;
  totalReviewsCount: number;
  reviewData: IReviewData[];
  selectedReviews: IReviewData[] = [];
  showOverview = true;
  cols: ICols[] = [];
  offset = 0;
  pageSize = 50;
  reviewsData: IReviewsMetrics;
  filters: IFitersObject = { DATE: ['Last 12 months'] };
  actionItems = [
    {
      label: `This page (0 items)`,
      command: () => {
        this.exportAllReviews(this.reviewTbl);
      },
      disabled: false,
      id: 'selectAll',
    },
    {
      label: 'All items (up to 10,000)',
      command: () => {
        this.exportFilteredReviews();
      },
    },
  ];
  public loading: boolean = true;
  public selectAllReviews: boolean = false;
  public search: string = '';
  public locationTagCounts: any;
  public displayReviewsCard: boolean = true;
  public dailyAvgRatings: any;
  public dailyTotalReviews: any;
  public startDate: string;
  public endDate: string;

  private enableSelectAllReviews: boolean = false;
  private ngUnsubscribe$: Subject<any> = new Subject();
  private selectedDateRange: string = 'DefaultDate';
  private dateRangeSet = new Set([
    'This month',
    'Last 30 days',
    'Last month',
    'Year to date',
    'Last 12 months',
  ]);
  private accountId: number;
  private loginId: number;
  private responsedReview: IReviewData | undefined;

  constructor(
    public dbService: DBService,
    public socketService: SocketService,
    private notifyService: NotifyService,
    private tableFilterService: TableFilterService,
    private dialogService: DialogService,
    public sessionService: SessionService,
    private exportDataToFile: ExportDataToFile,
    private reviewsCopyClipboardService: ReviewsCopyClipboardService
  ) {}

  ngOnInit(): void {
    this.getCurrentAccount();
    this.getLoginId();
    this.loadReviewsData();
    this.loadReviews();
    this.loadLocationTags();

    this.filterData.push(
      {
        type: FILTER_TYPES.MULTI,
        title: 'REVIEWS',
        options: ['Responded to', 'Not yet responded to'],
      },
      {
        type: FILTER_TYPES.MULTI,
        title: 'RATINGS',
        options: ['5', '4', '3', '2', '1'],
      },
      {
        type: FILTER_TYPES.DATE,
        title: 'DATE',
        options: ['This month', 'Last 30 days', 'Last month', 'Year to date', 'Last 12 months'],
      },
      {
        type: FILTER_TYPES.SINGLE,
        title: 'REVIEW TEXT',
        options: ['Review includes text', 'Review does not include text'],
      }
    );

    this.cols = [
      { field: 'storeCode', header: 'STORE CODE' },
      { field: 'businessName', header: 'LOCATION NAME' },
      { field: 'addressLines', header: 'STREET ADDRESS' },
      { field: 'city', header: 'CITY' },
      { field: 'state', header: 'STATE' },
      { field: 'postalCode', header: 'POSTAL CODE' },
      { field: 'tags', header: 'TAGS' },
      { field: 'reviewCreatedAt', header: 'REVIEW DATE' },
      { field: 'reviewerComment', header: 'REVIEW' },
      { field: 'reviewerName', header: 'REVIEWER NAME' },
      { field: 'starRating', header: 'RATING' },
      { field: 'replyUpdatedAt', header: 'RESPONSE DATE' },
      { field: 'replyComment', header: 'RESPONSE' },
    ];

    // this.broadcastService.subscribe('reviewGMBUpdated', (item) => {
    //   if (this.responsedReview) {
    //     // Removing the responded review from the list of all reviews.
    //     this.reviewData = this.reviewData.filter((r) => r._id !== this.responsedReview._id);
    //     // Updating the total reviews count.
    //     this.totalReviewsCount = this.totalReviewsCount - 1;
    //   }
    // });
  }

  /**
   * @description: Get the account details.
   */
  private getCurrentAccount(): void {
    this.sessionService
      .getSelectedAccount$()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((account: IAccount) => {
        this.accountId = account?._id;
      });
  }

  /**
   * @description: Get the current user details.
   * @returns: void
   * @arguments: void
   */
  private getLoginId(): void {
    this.sessionService
      .getCurrentUser$()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((user) => {
        this.loginId = user?.login?._id;
      });
  }

  userSearch(): void {
    this.loadReviewsData();
    this.loadReviews();
  }

  // dashboard
  toggleOverview() {
    this.showOverview = !this.showOverview;
  }

  hideOverview(toggle: boolean) {
    this.showOverview = !toggle;
  }

  // initial load
  loadReviewsData() {
    const request1$ = from(
      this.socketService.sendRequest('get-review-metrics', { includeAllTime: true, where: this.buildWhereClause() })
    );
    const request2$ = from(
      this.socketService.sendRequest('get-daily-review-metrics', {
        excludePast30Days: true,
        where: this.buildWhereClause(),
      })
    );

    zip(request1$, request2$)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        ([res1, res2]: [IReviewsMetricsResponse, any]) => {
          if (res1['collection'][0] || res2['collection']) {
            if (this.dateRangeSet.has(this.selectedDateRange)) {
              this.startDate = res1['collection'][0]?.dateStart;
              this.endDate = res1['collection'][0]?.dateEnd;
            }
            const dataSet1 = res1['collection'] && res1['collection']?.length && res1['collection'][0];
            this.totalReviewsCount = dataSet1['totalReviews'] || 0;
            this.dailyAvgRatings =
              res2['collection'] &&
              res2['collection'].length &&
              res2['collection'].map((el) => ({ date: el.date, value: +el.average_starrating }));
            this.dailyTotalReviews =
              res2['collection'] &&
              res2['collection'].length &&
              res2['collection'].map((el) => ({ date: el.date, value: +el.total_reviews }));
            this.reviewsData = { ...dataSet1 };
          } else {
            this.notifyService.error('There is no data for this account');
          }
        },
        (err: Error) => {
          this.notifyService.error('There is no data for this account');
        }
      );
  }

  loadLocationTags() {
    this.socketService.sendRequest('get-location-tags-and-counts', {}).then(
      (repl: any) => {
        this.filterData.push({
          type: FILTER_TYPES.MULTI,
          title: 'TAGS',
          options: repl.collection.map((l) => l.tagName), // + ' (' + l.locations + ')')
        });
      },
      (err: Error) => {
        console.log(err);
      }
    );
  }

  private buildWhereClause(): Array<string> {
    const filterClauses: string[][] = [];
    const tempFilterArr: string[] = [];
    const isFiltersApplied = this.chipsArray.length > 0;

    const pushQueriesToMainArray = () => {
      let filterClause: Array<string> = ['-or'];
      filterClause = filterClause.concat(tempFilterArr);
      filterClauses.push(filterClause);
      tempFilterArr.length = 0;
    };

    // build query if filtering is used
    if (isFiltersApplied) {
      for (const [key, value] of Object.entries(this.filters)) {
        if (value.length > 0 && value[0] != undefined) {
          switch (key) {
            case 'TAGS':
              value.forEach((tag: string) => tempFilterArr.push(`tags @> '{"${tag}"}'`));
              pushQueriesToMainArray();
              break;
            case 'REVIEWS':
              value.forEach((element: string) => {
                element == 'Responded to'
                  ? tempFilterArr.push(`NOT replyComment IS NULL`)
                  : tempFilterArr.push(`replyComment IS NULL`);
              });
              pushQueriesToMainArray();
              break;
            case 'RATINGS':
              value.forEach((element: string) => {
                switch (element) {
                  case '5':
                    tempFilterArr.push(`starRating = 5`);
                    break;
                  case '4':
                    tempFilterArr.push(`starRating = 4`);
                    break;
                  case '3':
                    tempFilterArr.push(`starRating = 3`);
                    break;
                  case '2':
                    tempFilterArr.push(`starRating = 2`);
                    break;
                  case '1':
                    tempFilterArr.push(`starRating = 1`);
                    break;
                }
              });
              pushQueriesToMainArray();
              break;
            case 'DATE':
              value.forEach((element: string) => {
                this.selectedDateRange = element;
                switch (element) {
                  case 'This month':
                    tempFilterArr.push(
                      `extract(month from r.date) = extract(month from current_date) and extract(year from r.date) = extract(year from current_date)`
                    );
                    break;
                  case 'Last 30 days':
                    tempFilterArr.push(`r.date > (now() - interval '30 day')`);
                    break;
                  case 'Last month':
                    tempFilterArr.push(
                      `extract(month from r.date) = extract(month from current_date) - 1 and extract(year from r.date) = extract(year from current_date)`
                    );
                    break;
                  case 'Year to date':
                    tempFilterArr.push(`extract(year from r.date) = extract(year from current_date)`);
                    break;
                  case 'Last 12 months':
                    tempFilterArr.push(`r.date > (now() - interval '12 month')`);
                    break;
                  case 'DefaultDate':
                    this.startDate = new Date().toISOString().slice(0, 10);
                    this.endDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().slice(0, 10);
                    tempFilterArr.push(`r.date > (now() - interval '30 day')`);
                    break;
                  default:
                    const dateArray: string[] = element.split(' - ');
                    this.startDate = dateArray[0];
                    this.endDate = dateArray[1];
                    tempFilterArr.push(`reviewCreatedAt >= '${dateArray[0]}' AND reviewCreatedAt <= '${dateArray[1]}'`);
                    break;
                }
              });
              pushQueriesToMainArray();
              break;
            case 'REVIEW TEXT':
              value.forEach((element: string) => {
                switch (element) {
                  case 'Review includes text':
                    tempFilterArr.push(`reviewercomment IS NOT NULL`);
                    break;
                  case 'Review does not include text':
                    tempFilterArr.push(`reviewercomment IS NULL`);
                    break;
                }
              });
              pushQueriesToMainArray();
              break;
          }
        }
      }
    } else {
      this.selectedDateRange = 'DefaultDate';
      this.startDate = new Date().toISOString().slice(0, 10);
      this.endDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().slice(0, 10);
      // Adding default lst 30 days option if no date filter is selected.
      tempFilterArr.push(`r.date > (now() - interval '30 day')`);
      pushQueriesToMainArray();
    }

    // build query if searching is used
    if (this.keyword) {
      tempFilterArr.push(`storeCode::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`businessName::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`tags::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`addressLines::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`city::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`state::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`postalCode::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`reviewerComment::text ~* '\\y${this.keyword}'`);
      tempFilterArr.push(`replyComment::text ~* '\\y${this.keyword}'`);
      pushQueriesToMainArray();
    }

    // join all queries
    let whereClauseArray: Array<any> = ['-and', "r._status IN ('A', 'UA', 'UP')", "vendorIdent='gmb'"];
    whereClauseArray = whereClauseArray.concat(filterClauses);
    return whereClauseArray;
  }

  private loadReviews() {
    this.loading = true;

    if (this.loading) {
      this.selectAllReviews = false;
      if (!this.selectAllReviews) {
        this.selectedReviews = [];
      }
    }

    this.dbService.ReviewGMB.loadObjects({
      columns: ['state'],
      offset: this.offset,
      limit: this.pageSize,
      order: this.sortOrder,
      where: this.buildWhereClause(),
    })
      .then(
        (repl) => {
          this.reviewData = repl.collection.map((item) => {
            return {
              ...item,
              tags: item?.tags && item?.tags.length && item.tags.join(', ').replace(/_/g, ' ').split(','),
            };
          });

          this.totalReviewsCount = repl.totalEntries;

          this.actionItems.forEach((item) => {
            if (item.id === 'selectAll') {
              item.label = `This page (${this.reviewData.length} items)`;
            }
          });

          for (const obj of this.reviewData) {
            this.datePosted = obj.reviewCreatedAt;
            if (obj.reviewerComment != null) {
              obj.reviewTooltip = `<span style="font-style: italic; padding-bottom: 15px">"${obj.reviewerComment}"</span>
                           <p style="text-align: left; margin-top: 12px"><b>Posted by</b> ${obj.reviewerName} on <b>${obj.reviewCreatedAt.month}/${obj.reviewCreatedAt.day}/${obj.reviewCreatedAt.year} ${obj.reviewCreatedAt.hour}:${obj.reviewCreatedAt.minute}</b></p>`;
            }
            if (obj.replyComment != null) {
              obj.replyTooltip = `<span style="font-style: italic; padding-bottom: 15px">"${obj.replyComment}"</span>
                           <p style="text-align: left; margin-top: 12px"><b>Posted on ${obj.replyUpdatedAt.month}/${obj.replyUpdatedAt.day}/${obj.replyUpdatedAt.year} ${obj.replyUpdatedAt.hour}:${obj.replyUpdatedAt.minute}</b></p>`;
            }
          }
        },
        (err: Error) => {
          this.reviewData = [];
          console.warn('Error loading ReviewGMB: %j', err);
        }
      )
      .finally(() => {
        this.loading = false;
      });
  }

  openEditResponse(review: IReviewData) {
    this.dialogService
      .open(AddEditResponseComponent, {
        data: {
          review: review,
          accountId: this.accountId,
          loginId: this.loginId,
        },
        closable: false,
        width: '70%',
        height: '70%',
      })
      .onClose.pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((res: { publishObject, confirmed: boolean }) => {
        if (!res.confirmed) {
          return;
        };
        const data = res.publishObject.data;
        this.reviewData = this.reviewData.map((r) => {
          if (r._id === data._id) {
            return {
              ...r,
              replyComment: data.replyComment,
            };
          }
          return r;
        });
      });
  }

  openDeleteResponse(review: IReviewData) {
    this.dialogService.open(DeletePopupComponent, {
      data: { ...review, actionType: 'Response' },
      closable: false,
      width: '40%',
    });
  }

  deleteReview(review: IReviewData) {
    this.dialogService
      .open(DeletePopupComponent, {
        data: { ...review, actionType: 'Review' },
        closable: false,
        width: '40%',
      })
      .onClose.subscribe((res) => {
        if (res) {
          this.notifyService.success('Success: Review deleted successfully.');
          this.loadReviews();
        } else {
          this.notifyService.error('Error: Error in deleting the Review. Please try again!');
        }
      });
  }

  addMultiReply() {
    this.showMultiReplyPopup = true;
  }

  cancelMultiReply() {
    this.showMultiReplyPopup = false;
  }

  getInfoFromDialog(toggle: boolean) {
    this.showMultiReplyPopup = toggle; // close the dialog
    this.selectedReviews = [];
    this.selectAllReviews = false;
  }

  exportReviews(table: Table, all?: boolean) {
    table.exportCSV(all ? '' : { selectionOnly: true });
  }

  public exportAllReviews(table: Table): void {
    this.enableSelectAllReviews = !this.enableSelectAllReviews;
    if (this.enableSelectAllReviews) {
      this.selectedReviews = this.reviewData;
      table.exportCSV();
    }
  }

  public lazyLoadLocations(event: LazyLoadEvent): void {
    if (event.sortField == 'directory') {
      return;
    }

    this.offset = event.first;
    if (event.sortField) {
      this.sortOrder = `${event.sortField}${event.sortOrder < 0 ? ' DESC' : ''}`;
    }
    this.loadReviews();
  }

  onChipsRefresh(filters: IFitersObject) {
    this.chipsArray = [].concat.apply([], Object.values(filters)); // merge all checkbox values into one array
    this.chipsArray = this.chipsArray.filter((e) => e); // remove all possible undefined
    if (!filters.hasOwnProperty('DATE')) {
      filters = { ...filters, DATE: ['DefaultDate'] };
    } else if (filters.hasOwnProperty('DATE') && !filters['DATE'].length) {
      filters = { ...filters, DATE: ['DefaultDate'] };
    }

    this.filters = filters;
    this.loadReviewsData();
    this.loadReviews();
  }

  onRowSelect(event) {
    this.selectAllReviews = this.selectedReviews.length === this.reviewData.length;
  }

  public exportFilteredReviews(): void {
    const params = {
      order: this.sortOrder,
      where: this.buildWhereClause(),
    };

    this.exportDataToFile.getReviews(params);
  }

  public handleSelectAllReviews(event): void {
    this.selectedReviews = event?.checked ? this.reviewData : [];
  }

  public toggleReviewsCardView() {
    this.displayReviewsCard = !this.displayReviewsCard;
  }

  public copyReviewToClipboard(review: IReviewData): void {
    const reviewsObjectCopy = this.reviewsCopyClipboardService.mapReviewDataCopyObject(review);
    const reviewsTextCopy = this.reviewsCopyClipboardService.mapReviewsDataCopyString(reviewsObjectCopy);
    const textArea = document.createElement('textarea');
    textArea.value = reviewsTextCopy;
    navigator.clipboard.writeText(textArea.value);
    this.notifyService.success('Review copied to clipboard');
  }

  ngOnDestroy(): void {
    this.tableFilterService.clearFilters(); // clear table filters
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
